<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pt-20 pb-20">
        <div class="flex align-center justify-between">
          <div class="flex align-center">
            <h1 tabindex="0" class="m-0">{{ isProjectRoute ? 'Projects' : 'Dashboard' }}</h1>
            <template v-if="isAdmin && isProjectRoute">
              <label for="project-filter" class="sr-only"> Project Filter </label>
              <select id="project-filter" class="form-control ml-10" v-model="showMineOnly">
                <option :value="true">My Projects</option>
                <option :value="false">All Projects</option>
              </select>
            </template>
          </div>
          <div class="flex align-center">
            <template v-if="isAdmin && isProjectRoute">
              <span class="form-inline">
                <span class="form-group">
                  <label for="search"><small>Search All</small></label>
                  <input
                    id="search"
                    type="text"
                    v-model.lazy="searchText"
                    class="form-control"
                    data-testid="search-all"
                  />
                </span>
              </span>
            </template>

            <router-link
              :tag="'button'"
              class="btn btn-lg btn-success mat ml-10"
              :to="{ name: 'new-version' }"
            >
              <span class="fas fa-plus-circle mr-5"></span> New Project</router-link
            >
          </div>
        </div>
      </div>

      <template v-if="!isProjectRoute">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <recent-projects />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <featured-projects />
          </div>

          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
            <resource-library />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <milestones />
          </div>
        </div>
      </template>
      <template v-if="isProjectRoute">
        <list-versions
          :search-text="searchText"
          :show-mine-only="showMineOnly"
          :isAdmin="isAdmin"
        />
      </template>

      <modal @closed="onDismissOnboardVid" :show-footer="false" :size="'lg'" id="onboarding-video">
        <h3 class="m-0" slot="title">Welcome to the CapsimInbox Authoring Platform</h3>
        <div slot="body" class="embed-responsive embed-responsive-16by9">
          <video ref="onboardVideo" controls class="embed-responsive-item">
            <source :src="videoSrc" type="video/mp4" />
          </video>
        </div>
      </modal>

      <template v-if="!isAdmin && !isAgreed">
        <terms-of-use-modal @showDeleteModal="showDeleteModal"></terms-of-use-modal>
        <delete-modal @showUpdatedTermModal="showUpdatedTermModal"> </delete-modal>
      </template>
    </div>
  </div>
</template>

<script>
  import ListVersions from './VersionList';
  import TermsOfUseModal from './TermofUseModal';
  import DeleteModal from './DeleteModal';
  import RecentProjects from './RecentProjects';
  import ResourceLibrary from './ResourceLibrary';
  import Milestones from './Milestones';
  import FeaturedProjects from './FeaturedProjects';

  import * as authorApi from '@authoringPlatform/../api/authors';

  import { mapState, mapActions } from 'vuex';
  export default {
    name: 'Dashboard',

    data() {
      return {
        videoSrc: '/capsiminbox/resources/Authoring_Welcome_Update.mp4',
        searchText: '',
        showMineOnly: true,
        error: '',
        isProjectRoute: false,
      };
    },
    created() {
      this.getAllVersions();
      this.getMilestonesForAuthor({ authorKey: this.actorKey });

      this.getRemainingMilestonesForAuthor({ authorKey: this.actorKey });
      this.getAuthorProjects();
    },

    computed: {
      ...mapState('user', ['isAgreed', 'isAdmin', 'loginCt', 'playOnboard', 'actorKey']),
      ...mapState('versions', ['authorProjects']),
      ...mapState(['milestones']),
    },

    components: {
      ListVersions,
      TermsOfUseModal,
      DeleteModal,
      RecentProjects,
      ResourceLibrary,
      FeaturedProjects,
      Milestones,
    },

    watch: {
      $route(to, from) {
        if (this.$route.path.includes('projects')) {
          this.getAllVersions();
          this.isProjectRoute = this.$route.path.includes('projects');
        } else {
          this.isProjectRoute = false;
        }
        if (this.$route.path.includes('dashboard')) {
          this.getAllRecentProjects({ authorKey: this.actorKey });
          this.getAllFeaturedProjects();
        }
      },
    },

    async mounted() {
      await authorApi.getMilestonesForAuthor(this.actorKey);

      const isDashboard = this.$route.path.includes('dashboard');
      this.isProjectRoute = this.$route.path.includes('projects');

      if (isDashboard) {
        this.getAllRecentProjects({ authorKey: this.actorKey });
        this.getMilestonesForAuthor({ authorKey: this.actorKey });
        this.getAllFeaturedProjects();
      }

      this.getAllVersions();

      // The home class is added to the root div via Handlebars. We need to remove it once the user is logged in to properly display the main IAP layout
      // TODO: find another way to change this
      $('body').removeClass('home');

      if (this.loginCt === 1 && this.playOnboard) {
        $('#onboarding-video').modal('show');
      }
      if (!this.isAgreed && !this.isAdmin) {
        $('#updated-term-modal').modal({ backdrop: 'static', keyboard: false });
      }
    },

    methods: {
      ...mapActions(['getMilestonesForAuthor', 'getRemainingMilestonesForAuthor']),
      ...mapActions('user', ['disableOnboardVid']),
      ...mapActions('versions', [
        'getAllVersions',
        'getAllRecentProjects',
        'getAllFeaturedProjects',
        'getAuthorProjects'
      ]),

      onDismissOnboardVid() {
        this.$refs.onboardVideo.pause();
        this.disableOnboardVid();
      },
      showDeleteModal() {
        if (!this.isAgreed) {
          $('#delete-modal').modal({ backdrop: 'static', keyboard: false });
        }
      },
      showUpdatedTermModal() {
        // if user doesn't decide to delete the account click back
        if (!this.isAgreed) {
          $('#updated-term-modal').modal({ backdrop: 'static', keyboard: false });
        }
      },
    },
  };
</script>
<style lang="scss">
  .banner {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16), 0 0 4px 1px rgba(0, 0, 0, 0.08);
  }
</style>
